import { render, staticRenderFns } from "./QDropdownNav.vue?vue&type=template&id=3fa7489b&"
import script from "./QDropdownNav.vue?vue&type=script&lang=js&"
export * from "./QDropdownNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports